export function DeepSeekLogo({ className = "h-8 w-8" }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden>
      <path
        d="M8 24c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16S8 32.837 8 24Z"
        fill="#4D6BFE"
        opacity="0.16"
      />
      <path
        d="M14 27c0-6.075 4.925-11 11-11 3.2 0 6.08 1.367 8.09 3.545l-3.39 2.55A6.5 6.5 0 0 0 25 20.5c-3.59 0-6.5 2.91-6.5 6.5 0 .42.04.83.117 1.227A6.99 6.99 0 0 0 18 28.4c-.03-.466-.05-.933-.05-1.4h-3.9c0 .41.025.817.075 1.22L13 27h1Z"
        fill="#4D6BFE"
      />
      <path
        d="M18.68 31.1c.977 1.3 2.545 2.4 4.32 2.4 3.035 0 5.5-2.465 5.5-5.5 0-1.03-.28-1.99-.77-2.81a11.03 11.03 0 0 1 3.9 1.06 1.95 1.95 0 0 0 .26 1.75c.5.765 1.55 1.085 2.375.59L36 26.9c.635-.38.78-1.2.42-1.84-1.017-1.82-2.65-3.37-4.6-4.46A8.49 8.49 0 0 0 26 15c-5.107 0-9.28 4.03-9.5 9.08-.18.04-.35.09-.52.15a6.6 6.6 0 0 1 2.7 6.87Z"
        fill="#4D6BFE"
      />
      <circle cx="31.5" cy="17.5" r="2.3" fill="#4D6BFE" />
    </svg>
  );
}

export function LogoMark({ className = "h-6 w-6" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path
        d="M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z"
        fill="#4D6BFE"
        opacity="0.16"
      />
      <path
        d="M7 13.5a5 5 0 0 1 5-5c1.46 0 2.77.62 3.68 1.61l-1.54 1.16A2.95 2.95 0 0 0 12 10.6c-1.63 0-2.96 1.32-2.96 2.96 0 .19.02.38.05.56A3.18 3.18 0 0 0 8.18 13a5.9 5.9 0 0 1-.1-1.1H6.2c0 .19.01.37.04.55l.76 1.05Z"
        fill="#4D6BFE"
      />
      <path
        d="M8.49 14.4c.44.6 1.16 1.1 1.97 1.1 1.38 0 2.5-1.12 2.5-2.5 0-.47-.13-.9-.35-1.28.58.26 1.12.6 1.6 1.02l.03.12a.88.88 0 0 0 .12.79c.22.35.7.5 1.08.27l.14-.1c.29-.17.35-.55.19-.84-.46-.83-1.2-1.53-2.09-2.02A3.86 3.86 0 0 0 12.72 9.4 4.12 4.12 0 0 0 9.5 8.3c-2.1 0-3.83 1.63-4.03 3.7-.08.02-.16.04-.24.07a3 3 0 0 1 1.23 3.12l1.03 1.2Z"
        fill="#4D6BFE"
      />
      <circle cx="15.2" cy="8.8" r="1" fill="#4D6BFE" />
    </svg>
  );
}

export function DeepSeekWordmark({ className = "h-6" }: { className?: string }) {
  return (
    <svg viewBox="0 0 210 30" fill="none" className={className} aria-hidden>
      <text
        x="0"
        y="23"
        fontFamily="Inter, system-ui, sans-serif"
        fontWeight="700"
        fontSize="24"
        fill="#212327"
      >
        DeepSeek
      </text>
    </svg>
  );
}
